import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import Button from "common/components/CustomButtons/Button.jsx";

// @material-ui/core components
import AirplanemodeActive from "@material-ui/icons/AirplanemodeActive";

import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center"
  },
  containerLine: {
    marginTop: "20px"
  },
  editButton: {
    textAlign: "right",
    margin: "10px"
  },
  maxHeight: {
    maxHeight: "400px"
  }
};

const LongDistanceBalanceCard = props => {
  const { classes } = props;
  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <AirplanemodeActive />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>International Calling Balance</h4>
      </CardHeader>
      <CardBody>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>Balance </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>
              ${" "}
              {props.getData("balance") === null ? 0 : props.getData("balance")}{" "}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="flex-end">
          <GridItem className={classes.editButton} xs={12}>
            <Button
              color="primaryLightBlue"
              onClick={props.onClickLongDistanceBalanceAdd}
            >
              Add
            </Button>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/voipldbalance",
    LongDistanceBalanceCard
  )
);
